import React from 'react';

const Medium = (props: any) => (
  <span {...props}>
    <svg width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="medium">
        <circle id="&#230;&#164;&#173;&#229;&#156;&#134;&#229;&#189;&#162;" cx="15" cy="15" r="15" fill="#000" />
        <g id="twitter">
          <g id="LGDRR5GWQFPLU">
            <path
              id="&#229;&#189;&#162;&#231;&#138;&#182;"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.5 9.89565L18.3593 18.1773L15.413 13.7573L17.9168 8.75L22.5 9.89565ZM8.75 21.3541V11.0415L13.3335 12.1874V22.5L8.75 21.3541ZM17.9168 19.0624L14.1927 18.1315V13.4766L17.9168 19.0624ZM18.7706 19.2761L22.5 20.2082V11.8165L18.7706 19.2761Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  </span>
);

export default Medium;
